import type { ListBuilderList } from '../../../types';
import { createShopStandardColumns } from '../columns';
import {
	SHOP_MOBILE_CARD_CONFIG,
	SHOP_STANDARD_REQUIRED_FIELDS,
} from '../shared';

/**
 * Shop Popular list configuration (PD-14017)
 *
 * Tenant-wide top sellers: the 100 items bought by the most distinct
 * accounts over the last 12 months (the `popular` item filter in
 * client-item.service.ts). Sits beside "Recommended" on purpose —
 * popularity used to be a factor inside Recommended, but the account
 * recommender (PD-14016) is account-specific now, so popularity gets a
 * clear home of its own.
 *
 * `in_stock` is included by default for the same reason as Recommended:
 * surfacing items the user can't add to a cart wastes a click.
 */
export const shopPopularList: ListBuilderList = {
	id: 'shop_popular',
	cacheTTL: 600000,
	name: 'Popular',
	type: 'default',
	active: true,
	sortOrder: 7,
	columns: createShopStandardColumns(),
	description: 'Top sellers across all accounts (last 12 months)',
	defaultSortId: 'in_stock_first',
	requiredFields: SHOP_STANDARD_REQUIRED_FIELDS,
	mobileCardConfig: SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'popular',
					label: 'Popular',
				},
				{
					id: 'in_stock',
					label: 'In Stock',
				},
			],
		},
	},
};
